module.exports = __webpack_public_path__ + "img/attachment-blue-24-dp.645744f6.svg";